import styled from "styled-components";

export const Container = styled.div`
	background-color: #f9f9f9;
	margin: 5px;
	border-radius: 20px;
	box-shadow: 0px 0px 5px black;
	overflow: hidden;
	display: flex;
	justify-content: space-around;
	padding: 10px;
	align-items: center;

	cursor: pointer;
	transition-duration: 0.2s;

	&:hover {
		box-shadow: 0px 0px ${5 * 2}px gray;
	}
`;

export const ButtonContainer = styled.div`
	height: 50px;
	display: flex;
	justify-content: center;
	margin-top: 20px;
`;
